import { memo } from 'react';
import { Snackbar, Alert } from '@mui/material';
export const SnackbarMessage = memo(function SnackbarMessage({ anchorOrigin, open, duration, closeDelegate, message, severity }) {
    return (<Snackbar anchorOrigin={anchorOrigin ?? { vertical: 'bottom', horizontal: 'center' }} open={open} autoHideDuration={duration ?? 2000} onClose={closeDelegate}>
      <Alert onClose={closeDelegate} severity={severity ?? 'error'} variant='filled'>
        {message}
      </Alert>
    </Snackbar>);
});
